// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"77829b4e","919":"768ceda5"}[chunkId] + ".chunk.js";
};